<div class="min-h-screen bg-elite-50 flex items-center justify-center">
  <div class="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-lg border border-elite-200">
    <div>
      <div class="flex justify-center mb-4">
        <img src="/logodenotext.jpg" alt="Deportes Élite Logo" class="h-32 w-auto rounded-lg">
      </div>
      <h2 class="mt-6 text-center text-3xl font-extrabold text-elite-secondary-500 font-cocogoose">
        Deportes Élite
      </h2>
      <p class="mt-2 text-center text-sm text-elite-accent-600">
        Inicia sesión en tu cuenta
      </p>
    </div>
    
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="mt-8 space-y-6">
              <div class="rounded-md shadow-sm -space-y-px">
          <div>
            <label for="username" class="sr-only">Usuario</label>
            <input
              id="username"
              name="username"
              type="text"
              formControlName="username"
              required
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-elite-200 placeholder-elite-accent-400 text-elite-secondary-700 rounded-t-md focus:outline-none focus:ring-elite-500 focus:border-elite-500 focus:z-10 sm:text-sm"
              placeholder="Usuario"
            />
          </div>
        <div>
          <label for="password" class="sr-only">Contraseña</label>
          <input
            id="password"
            name="password"
            type="password"
            formControlName="password"
            required
                          class="appearance-none rounded-none relative block w-full px-3 py-2 border border-elite-200 placeholder-elite-accent-400 text-elite-secondary-700 rounded-b-md focus:outline-none focus:ring-elite-500 focus:border-elite-500 focus:z-10 sm:text-sm"
            placeholder="Contraseña"
          />
        </div>
      </div>

      <div *ngIf="error" class="text-red-600 text-sm text-center bg-red-50 border border-red-200 rounded-md p-3">
        {{ error }}
      </div>

      <div>
        <button
          type="submit"
          [disabled]="isButtonDisabled"
          class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md text-sm font-medium text-white bg-elite-500 hover:bg-elite-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-elite-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 font-cocogoose"
        >
          <span *ngIf="!loading">Iniciar sesión</span>
          <span *ngIf="loading" class="flex items-center">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Cargando...
          </span>
        </button>
      </div>
    </form>
  </div>
</div>